module.exports = __webpack_public_path__ + "fonts/font.235318c.woff2";